import cx from 'classnames';
import type { ReactNode } from 'react';
import './tabs.scss';

interface TabsProps {
  items: { name: ReactNode; value: string; counter?: number }[];
  selected: string;
  $flex?: 'fill' | 'grow';
  mobileScrollable?: boolean;
  onTabChange: (tab: string) => void;
}

const Tabs = ({
  items,
  selected,
  $flex,
  mobileScrollable,
  onTabChange,
}: TabsProps): JSX.Element => {
  return (
    <div
      className={cx('tabs', {
        'tabs--mobile-scrollable': mobileScrollable,
      })}
    >
      {items.map(({ value, name, counter }) => (
        <div
          className={cx('tabs__tab', {
            'tabs__tab--selected': selected === value,
            'tabs__tab--grow': $flex === 'grow',
          })}
          key={value}
          onClick={() => onTabChange(value)}
        >
          <div className="tabs__title">{name}</div>
          {!!counter && <span className="tabs__counter">{counter}</span>}
        </div>
      ))}
      {$flex === 'fill' && <div className="tabs__tab tabs__tab--fill"></div>}
    </div>
  );
};

export default Tabs;
